/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Theme, teamsDarkTheme, teamsHighContrastTheme, teamsLightTheme } from "../packages/fluent9";

import { ThemeType } from "./ThemeType";

/**
 * Gets the Microsoft Teams entrypoint theme from given theme identifier.
 * @param theme The theme identifier.
 * @returns The Teams entrypoint theme.
 */
export const getTeamsEntrypointTheme = (theme: ThemeType): Theme => {
    switch (theme) {
        case ThemeType.Dark:
            return teamsDarkTheme;
        case ThemeType.HighContrast:
            return teamsHighContrastTheme;
        case ThemeType.Light:
            return teamsLightTheme;
    }
};

/**
 * Gets the theme identifier from given Microsoft Teams entrypoint theme.
 * @param theme The Teams entrypoint theme.
 * @returns The theme identifier.
 */
export const getTeamsThemeType = (theme: string): ThemeType => {
    switch (theme) {
        case "dark":
            return ThemeType.Dark;
        case "contrast":
            return ThemeType.HighContrast;
        case "light":
        default:
            return ThemeType.Light;
    }
};